export default __webpack_public_path__ + "static/media/livechat.468c3c25.jpg";